import axios from "axios";

const route = "/users/v1/public/address";
class GooglePlaceService {
	async suggest(qry) {
		const response = await axios.get(`${route}/search/${qry}`);
		return JSON.parse(response.data);
	}

	async findPlace(placeId) {
		const response = await axios.get(`${route}/place/${placeId}`);
		return JSON.parse(response.data);
	}
}

export default new GooglePlaceService();
